import { Box, Divider, Typography } from '@mui/material'
import React from 'react'

const Capsule = ({children, sx, title, contentSX, backgroundColor, titleBackgroundColor, titleSx}) => {
  return (
    <Box sx={{
        border: 1, 
        borderRadius: 1, 
        borderColor: '#ccc', 
        backgroundColor: backgroundColor || '#fff',
        width: '100%',
        overflow: 'hidden',
        ...sx
    }}>
        {title ? (
          <Box sx={{ backgroundColor: titleBackgroundColor || 'transparent' }}>
            <Typography 
              variant="h4"
              p={1}
              sx={{ ml: 1, color: "primary.main", fontWeight: "regular", ...titleSx }}
            >{title}</Typography>
            <Divider sx={{ borderColor: 'rgba(0, 0, 0, 0.1)' }}/>
          </Box>
        ) : null}
        <Box sx={{ p: 2, ...contentSX }}>
          {children}
        </Box>
    </Box>
  )
}

export default Capsule